// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Assistent',
  },
  close: {
    amigo: 'Luk Amigo',
    assistant: 'Luk assistenten',
  },
  brand: 'Brand',
  // No restaurant selected in the dashboard (D18): the header's line.
  no_restaurant: 'Ingen restaurant valgt',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Chats',
  new_chat: 'Ny chat',
  back: 'Tilbage til chatten',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'Nye svar i en anden chat',
  news_elsewhere_other: 'Nye svar i {{count}} andre chats',
};
